import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText, DollarSign, Check } from 'lucide-react';
import { useAuth } from '../auth/AuthProvider';
import { API_BASE } from '../../utils/constants';
import LoadingSpinner from '../ui/LoadingSpinner';

const MyTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const loadTransactions = async () => {
      try {
        const userId = localStorage.getItem('userId');
        const res = await fetch(`${API_BASE}/users/${userId}/transactions`);
        const data = await res.json();
        setTransactions(data);
      } catch (err) {
        console.error('Failed to load transactions', err);
      }
      setLoading(false);
    };

    if (user) {
      loadTransactions();
    }
  }, [user]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <button
          onClick={() => navigate('/dashboard')}
          className="inline-flex items-center text-teal-600 hover:text-teal-700 mb-4"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Dashboard
        </button>
        <h1 className="text-3xl font-bold text-gray-900">My Transactions</h1>
      </div>

      <div className="bg-white shadow overflow-hidden sm:rounded-md">
        {transactions.length === 0 ? (
          <div className="text-center py-12">
            <FileText className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900">No transactions yet</h3>
            <p className="mt-1 text-sm text-gray-500">Start by adding some expenses to see your transaction history.</p>
          </div>
        ) : (
          <ul className="divide-y divide-gray-200">
            {transactions.map((txn, index) => (
              <li key={index} className="px-6 py-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className={`flex-shrink-0 h-10 w-10 rounded-full flex items-center justify-center ${
                      txn.type === 'EXPENSE' ? 'bg-green-100' : 'bg-blue-100'
                    }`}>
                      {txn.type === 'EXPENSE' ? (
                        <DollarSign className="h-5 w-5 text-green-600" />
                      ) : (
                        <Check className="h-5 w-5 text-blue-600" />
                      )}
                    </div>
                    <div className="ml-4">
                      <div className="text-sm font-medium text-gray-900">{txn.description}</div>
                      <div className="text-sm text-gray-500">
                        {txn.groupName} • Paid by {txn.paidBy} • {txn.type}
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm font-medium text-gray-900">₹{txn.amount.toFixed(2)}</div>
                    <div className="text-sm text-gray-500">
                      {new Date(txn.date).toLocaleDateString()}
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default MyTransactions;